export const MitoGaugeStatus = {
    Active: 'active',
    Live: 'live',
};
